<template>
  <b-navbar type="light" class="navbar-light theme-nav fixed-top" toggleable="lg" fixed="top"  v-b-scrollspy:nav-scroller>
    <div class="container">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand href="#home" class="navbar-brand"><img style="height: 58.5px" :src='"../assets/images/logo.svg"' alt="logo"></b-navbar-brand>
    <b-collapse class="default-nav" is-nav id="nav_collapse">
      <b-navbar-nav class="navbar-nav ml-auto" id="mymenu">
          <!-- <b-nav-item href="#home">Home</b-nav-item> -->
          <b-nav-item class="mr-4" href="#about">{{ $t("nav.about-us") }}</b-nav-item>
          <b-nav-item class="mr-4" href="#feature">{{ $t("nav.our-services") }}</b-nav-item>
          <!-- <b-nav-item href="#screenshot">screenshot</b-nav-item> -->
          <!-- <b-nav-item href="#team">team</b-nav-item> -->

          <!-- <b-nav-item-dropdown right-alignment text="blog" class="nav-link">
		       <b-dropdown-item class="nav-link"   :href='"#blog"'>Blog</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'blog_list'}" >Blog list</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Blog_details'}" >Blog details</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Blog_leftside'}">Left sidebar</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Blog_rightside'}">Right sidebar</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'BlogLeftSidebar'}">Details left sidebar</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'BlogrightSidebar'}" >Details right sidebar</b-dropdown-item>
          </b-nav-item-dropdown> -->
          <b-nav-item class="mr-4" href="#why-us">{{ $t("nav.why-us") }}</b-nav-item>
          <b-nav-item class="mr-4" href="#our-app">{{ $t("nav.our-app") }}</b-nav-item>
          <b-nav-item class="mr-4" href="#contact">{{ $t("nav.contact-us") }}</b-nav-item>

          <!-- <b-nav-item-dropdown right-alignment href="#Other_page" text="Other page" class="nav-link ">
            <b-dropdown-item class="nav-link"  :to="{name:'Signin'}" :href='"/tovo/sign-in"'>sign in</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Signup'}" :href='"/tovo/sign-up"' >sign up</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'ForgetPassword'}" :href='"/tovo/forget-Password"' >Forget Password</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Thankyou'}" :href='"/tovo/thank-you"' >Thank you</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Review'}" :href='"/tovo/review"' >Review</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'pagenotfound'}" :href='"/tovo/404"' >404</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Faq'}" :href='"/tovo/faq"' >FAQ</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'download'}" :href='"/tovo/download"' >Download</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'coming_soon'}" :href='"/tovo/coming-soon"' >coming soon</b-dropdown-item>
          </b-nav-item-dropdown> -->

      </b-navbar-nav>
    </b-collapse>
    </div>
  </b-navbar>
</template>
<script>
  export default {
   name:'Navbar'
  }
</script>

<style lang="sass">
  .nav-link
    color: black !important
  .nav-link.active
    color: #55CEB9 !important
  .nav-link:hover
    color: #7FEBC5 !important
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue